<template>
    <!--滑动banner -->
    <div :class="['swiperbanner_container', { 'container-dark': theme_dark }]">
        <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item, index) in gif" :key="index">
                <ul class="ub ub-pc gif-block">
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[0])">
                        <img :src="item[0].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[1])">
                        <img :src="item[1].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[2])">
                        <img :src="item[2].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[3])">
                        <img :src="item[3].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[4])">
                        <img :src="item[4].url" class="gif-item" />
                    </li>
                </ul>

                 <ul class="ub ub-pc gif-block">
                    
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[5])">
                        <img :src="item[5].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[6])">
                        <img :src="item[6].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[7])">
                        <img :src="item[7].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[8])">
                        <img :src="item[8].url" class="gif-item" />
                    </li>
                    <li class="ub ub-ac ub-pc ub-f1" @click="tap_item(item[9])">
                        <img :src="item[9].url" class="gif-item" />
                    </li>
                  
                </ul>
            </swiper-slide>
            <div class="swiper-pagination" slot="scrollbar"></div>
        </swiper>
    </div>
</template>

<script>
    import * as tool from '../../api/common';
    //import const_data from '../../api/const_data';
    import { mapMutations, mapActions } from 'vuex'
    export default {
        name: "Swiper_Gif",
        data() {
            return {
                gif: [],

                swiperOption: {
                    direction: 'horizontal',

                    freeMode: false,
                    observeParents: true,   //观察父组件，当父组件变化时，自己随着变化
                    observer: true,     //观察自己，自己的参数变化时，更新
                    centeredSlides: true,   //设置为true时，活动块居中显示，默认下居左显示
                    loop: false,   //滑动过程中会在前后复制多个slider,效果看起来是循环的
                    loopedSlides: 3,   //设置滑动过程中所要用到的loop个数
                    slidesPerView: 'auto',   //同时显示的slide数量
                    loopAdditionalSlides: 100,
                    autoPlay: {
                        delay: 3000,
                        disableOnInteraction: false  //鼠标移动上去时是否继续播放
                    },
                    pagination: { el: ".swiper-pagination" },
                    paginationType: 'bullets',
                    paginationElement: 'span'
                },
                theme_dark: false
            }
        },
        props: {},
        mounted() {
            //切换深色模式
            this.theme_dark = tool.is_theme_dark(this);
            
            this.init_page();
        },
        methods: {
            ...mapMutations(['get', 'post']), //引入方法
            ...mapActions(['act_get_userinfo']), //引入方法

            tap_item(item) {
                var item = { 'type': 'gif', 'name': item.name, 'url': item.url }
                this.$emit("send_gif", item)
            },

            init_page() {
                var const_data = this.$store.state.const_data;
                var uid = this.$store.state.uid;
                var self = this;
                self.act_get_userinfo({
                    uid: uid,
                    success: function (u) {
                        if(u.sex == '男生'){
                            self.gif = tool.slice_arry(const_data.gif_boy, 10);
                        }
                        if(u.sex == '女生'){
                            self.gif = tool.slice_arry(const_data.gif_girl, 10);
                        }
                    }
                });
               
            }
        }
    }
</script>

<style lang="scss" scoped>
.swiperbanner_container {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    background-color: #fff;
    .swiper-pagination {
        bottom: 2px !important;
    }
}

.gif-block {
    height: 4.5rem;
    padding: .8rem;
    padding-bottom: 1.2rem;
    justify-content: space-around;
    .gif-item {
        height: 3.5rem;
        width: 3.5rem;
    }
}

.container-dark {
    background-color: #282828;
}
</style>